import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function BalerRefurbishingServices() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/service-department">Service Department</Link>
          <Link className="active" to="/baler-refurbishing-services">Baler Refurbishing Services</Link>
          <Link to="/baler-replacement-parts">Baler Replacement Parts</Link>
          <Link to="/baling-wire">Baling Wire</Link>
          <Link to="/contact/baling-wire">Baling Wire Quotation</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Parts &amp; Service</span>
          <h2>Baler Refurbishing Services</h2>
          <div className="content-stack">
            <section className="content-block">
              <div className="selection-media-row">
                <div className="selection-media-copy">
                  <div className="body-copy">C+M offers a factory <strong>rebuilding and refurbishing service</strong> for older C+M horizontal and vertical balers and most other brands of single ram <strong>horizontal balers</strong>.</div>
                  <div className="body-copy">Make your old baler 80 percent new by relying on the expertise of the C+M Baling Systems factory technicians and fabricators. Contact our C+M general sales department to discuss refurbishing your older baler, or email C+M at <a href="mailto:sales@baling.com">sales@baling.com</a>.</div>
                </div>
                <div className="service-image-stack">
                  <figure>
                    <img className="service-side-image" src="/img/thumbnails/BalingRefurbishingServicesPic1.jpg" alt="Baler before refurbishing" />
                    <figcaption>Before</figcaption>
                  </figure>
                  <figure>
                    <img className="service-side-image" src="/img/thumbnails/BalingRefurbishingServicesPic2.jpg" alt="Baler after refurbishing" />
                    <figcaption>After</figcaption>
                  </figure>
                </div>
              </div>
            </section>
            <div className="gold-note">Note: Photos and descriptions along with the baler brand, age, and model number are needed and always helpful in expediting your quotation for a C+M factory refurbished baler. C+M refurbishing is done correctly with a detailed checklist, not just casually. If your C+M baler only requires relining and new wear plates and guides, often the work can be completed at your facility. However, fire watch protection is required and the area must be free of combustible materials.</div>
           
          </div>
          <Link className="button" to="/contact/general-inquiry">Contact C+M <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default BalerRefurbishingServices;
